import {
  buildHeroImageUrl,
  buildShortHeroImageUrl,
  buildImageUrl,
} from '@/lib/imageUtils';

export interface SiteImage {
  id: string;
  section: string;
  page: string;
  label: string;
  defaultUrl: string;
  width: number;
  height: number;
}

export const siteImages: SiteImage[] = [
  // HOME PAGE
  {
    id: 'hero-bg',
    section: 'Hero Background',
    page: 'Home',
    label: 'Rockhound Auto Warrenton OR — Used Cars Oregon Coast Hero',
    defaultUrl: buildHeroImageUrl(
      'pacific northwest mountain landscape with evergreen pine forests and misty mountain peaks under dramatic cloudy sky showcasing natural beauty of oregon washington region with lush green wilderness and scenic mountain ranges professional nature photography',
      'hero-bg-pnw-002'
    ),
    width: 1920,
    height: 1080,
  },
  {
    id: 'about-interior',
    section: 'About Section',
    page: 'Home',
    label: 'Used Car Interior Detail — Rockhound Auto Warrenton Oregon',
    defaultUrl: buildImageUrl(
      '2023 black Chevrolet Colorado ZR2 luxury interior dashboard steering wheel leather seats center console modern technology touchscreen display premium materials high quality automotive photography professional lighting detailed close up shot',
      'square',
      'about-interior-colorado-zr2',
      'squarish'
    ),
    width: 320,
    height: 320,
  },
  {
    id: 'about-exterior',
    section: 'About Section',
    page: 'Home',
    label: 'Used Pickup Truck for Sale Oregon Coast — Rockhound Auto',
    defaultUrl: buildImageUrl(
      '2023 black Chevrolet Colorado ZR2 pickup truck exterior full vehicle side three quarter view rugged off road capable aggressive stance lifted suspension all terrain tires bold grille professional automotive photography natural outdoor lighting Pacific Northwest forest mountain backdrop',
      'portrait',
      'about-exterior-colorado-zr2',
      'portrait'
    ),
    width: 420,
    height: 560,
  },
  {
    id: 'service-inventory',
    section: 'Services Cards',
    page: 'Home',
    label: 'Hand-Selected Used Car Inventory — Rockhound Auto Warrenton OR',
    defaultUrl: buildImageUrl(
      'collection of diverse vehicles including sedans SUVs and trucks parked in open grassy meadow with wildflowers blue sky and distant mountains peaceful natural setting no buildings no signs no dealership branding just clean everyday consumer vehicles arranged casually in beautiful outdoor environment professional automotive lifestyle photography',
      'card',
      'inventory-meadow-collection-fresh-010',
      'landscape'
    ),
    width: 800,
    height: 600,
  },
  {
    id: 'service-broker',
    section: 'Services Cards',
    page: 'Home',
    label: 'Auto Broker Services Oregon Coast — Rockhound Auto Warrenton',
    defaultUrl: buildImageUrl(
      'two people having casual friendly conversation outdoors about car buying one person pointing at vehicle in background relaxed informal meeting between independent car broker and customer no office no suits just honest straightforward discussion in parking area natural daylight Pacific Northwest setting authentic real world car buying consultation',
      'card',
      'broker-casual-outdoor-meeting-v2',
      'landscape'
    ),
    width: 800,
    height: 600,
  },
  {
    id: 'service-concierge',
    section: 'Services Cards',
    page: 'Home',
    label: 'Car Buying Concierge Service — Rockhound Auto Oregon',
    defaultUrl: buildImageUrl(
      'person handing over car keys to buyer in casual outdoor setting natural daylight direct peer to peer car sale transaction friendly handoff of vehicle keys with car visible in background relaxed atmosphere no dealership setting private sale vibe honest straightforward exchange between two people shaking hands and exchanging keys realistic photography',
      'card',
      'car-buying-services-sell-direct-004',
      'landscape'
    ),
    width: 800,
    height: 600,
  },
  {
    id: 'service-consignment',
    section: 'Services Cards',
    page: 'Home',
    label: 'Vehicle Consignment Service Warrenton OR — Rockhound Auto',
    defaultUrl: buildImageUrl(
      'professional handshake deal with car keys and consignment paperwork on desk in modern dealership office setting business partnership agreement for vehicle consignment sale natural lighting clean professional atmosphere Pacific Northwest car dealer office realistic photography',
      'card',
      'consignment-handshake-deal-keys-paperwork-v1',
      'landscape'
    ),
    width: 800,
    height: 600,
  },
  {
    id: 'concierge-hero',
    section: 'Car Buying Services Section',
    page: 'Home',
    label: 'Car Buying Services Oregon Coast — Rockhound Auto Warrenton OR',
    defaultUrl: buildImageUrl(
      'person handing over car keys to buyer in casual outdoor setting natural daylight direct peer to peer car sale transaction friendly handoff of keys relaxed atmosphere no dealership setting private sale vibe honest straightforward exchange between seller and buyer shaking hands realistic photography warm inviting scene',
      'card',
      'concierge-sell-car-direct-005',
      'landscape'
    ),
    width: 800,
    height: 600,
  },
  // BROKER SERVICES PAGE
  {
    id: 'broker-hero',
    section: 'Hero Background',
    page: 'Broker Services',
    label: 'Auto Broker Services Warrenton Oregon — Rockhound Auto Pacific Northwest',
    defaultUrl: buildHeroImageUrl(
      'independent car broker reviewing vehicle options with customer in casual outdoor parking lot setting clipboard with car listings visible relaxed consultation no fancy office no showroom just honest straightforward car buying help Pacific Northwest background mountains and trees authentic used car business atmosphere',
      'brokerhero-outdoor-v2'
    ),
    width: 1920,
    height: 1080,
  },
  // BLOG PAGE
  {
    id: 'blog-hero',
    section: 'Hero Background',
    page: 'Blog',
    label: 'Car Buying Tips Blog — Rockhound Auto Oregon Coast',
    defaultUrl: buildShortHeroImageUrl(
      'modern automotive blog content creation workspace with laptop notebook coffee cup car magazines and vehicle photos on wooden desk natural window lighting professional automotive journalism writing environment Pacific Northwest office setting',
      'bloghero001'
    ),
    width: 1920,
    height: 600,
  },
  // FAQ PAGE
  {
    id: 'faq-hero',
    section: 'Hero Background',
    page: 'FAQ',
    label: 'Used Car FAQ Warrenton OR — Rockhound Auto Oregon Coast',
    defaultUrl: buildShortHeroImageUrl(
      'friendly car dealer answering customer questions in simple office setting basic desk with computer and paperwork casual professional atmosphere no luxury no fancy showroom just honest helpful consultation about used car buying Pacific Northwest small business environment',
      'faqhero-simple-v2'
    ),
    width: 1920,
    height: 600,
  },
  // SELL YOUR CAR PAGE
  {
    id: 'sellcar-hero',
    section: 'Hero Background',
    page: 'Sell Your Car',
    label: 'Sell Your Car Warrenton Oregon — Rockhound Auto Cash Offer',
    defaultUrl: buildShortHeroImageUrl(
      'person receiving cash payment for selling their car direct transaction handshake and money exchange in casual outdoor setting with vehicle visible in background honest straightforward car sale private party transaction no dealership Pacific Northwest setting natural lighting',
      'sellcarhero001'
    ),
    width: 1920,
    height: 600,
  },
  // COMPARE PAGE
  {
    id: 'compare-hero',
    section: 'Hero Background',
    page: 'Compare',
    label: 'Compare Rockhound Auto vs Dealerships — Oregon Coast Used Cars',
    defaultUrl: buildShortHeroImageUrl(
      'two used vehicles parked side by side in outdoor lot for comparison everyday cars no showroom no fancy lighting just honest vehicle comparison in natural daylight Pacific Northwest parking area simple straightforward car shopping',
      'comparehero-outdoor-v2'
    ),
    width: 1920,
    height: 600,
  },
  // COMMUNITY IMPACT PAGE
  {
    id: 'impact-hero',
    section: 'Hero Background',
    page: 'Community Impact',
    label: 'Rockhound Auto Community Impact — Oregon Dog Rescue Warrenton OR',
    defaultUrl: buildShortHeroImageUrl(
      'happy rescued dogs playing in Pacific Northwest outdoor setting with mountains and forests in background animal rescue sanctuary peaceful natural environment Puplandia rescue dogs enjoying freedom and care heartwarming scene',
      'impacthero001'
    ),
    width: 1920,
    height: 600,
  },
  {
    id: 'puplandia-about',
    section: 'About Puplandia',
    page: 'Community Impact',
    label: 'Puplandia Dog Rescue Partner — Rockhound Auto Warrenton Oregon',
    defaultUrl: buildImageUrl(
      'modern animal rescue facility with happy dogs in clean spacious kennels caring staff members interacting with rescued animals Pacific Northwest animal shelter professional veterinary care environment Puplandia rescue center warm inviting atmosphere',
      'card',
      'puplandia-facility-001',
      'landscape'
    ),
    width: 800,
    height: 600,
  },
  // SERVICE AREAS PAGE
  {
    id: 'serviceareas-hero',
    section: 'Hero Background',
    page: 'Service Areas',
    label: 'Rockhound Auto Service Areas — Oregon Coast & SW Washington Used Cars',
    defaultUrl: buildShortHeroImageUrl(
      'Pacific Northwest coastal highway scenic drive with ocean views evergreen forests and mountain ranges Oregon Washington coastline beautiful landscape road trip destination natural beauty',
      'serviceareashero001'
    ),
    width: 1920,
    height: 600,
  },
  // SOLD VEHICLES PAGE
  {
    id: 'sold-hero',
    section: 'Hero Background',
    page: 'Sold Vehicles',
    label: 'Sold Used Cars Warrenton OR — Happy Rockhound Auto Customers',
    defaultUrl: buildShortHeroImageUrl(
      'happy customer receiving car keys after purchasing used vehicle casual outdoor handoff celebrating successful car purchase handshake in parking lot Pacific Northwest setting satisfied buyer with their newly bought car joyful moment no showroom no fancy dealership',
      'soldhero-casual-v2'
    ),
    width: 1920,
    height: 600,
  },
  // TRADE-IN PAGE
  {
    id: 'tradein-hero',
    section: 'Hero Background',
    page: 'Trade-In',
    label: 'Trade In Your Car Warrenton Oregon — Rockhound Auto Fair Value',
    defaultUrl: buildShortHeroImageUrl(
      'used car dealer inspecting trade in vehicle in outdoor lot clipboard in hand checking condition of car casual professional appraisal no fancy facility just honest vehicle evaluation Pacific Northwest parking area natural daylight',
      'tradein-hero-outdoor-v2'
    ),
    width: 1920,
    height: 600,
  },
  {
    id: 'tradein-cta',
    section: 'CTA Banner',
    page: 'Trade-In',
    label: 'Get a Trade-In Offer Oregon Coast — Rockhound Auto Warrenton OR',
    defaultUrl: buildImageUrl(
      'person holding car keys with used vehicle visible in background outdoor setting natural lighting simple straightforward trade in transaction Pacific Northwest parking lot casual professional atmosphere',
      'banner',
      'tradein-cta-simple-v2',
      'landscape'
    ),
    width: 1200,
    height: 400,
  },
  // REVIEWS PAGE
  {
    id: 'reviews-hero',
    section: 'Hero Background',
    page: 'Reviews',
    label: 'Rockhound Auto Customer Reviews — Used Car Dealer Warrenton OR',
    defaultUrl: buildShortHeroImageUrl(
      'happy customer standing next to their newly purchased used car giving thumbs up smiling satisfied buyer in casual outdoor parking lot setting Pacific Northwest background mountains and trees authentic real customer testimonial moment no showroom no fancy dealership',
      'reviews-hero-authentic-v2'
    ),
    width: 1920,
    height: 600,
  },
  // INVENTORY PAGE
  {
    id: 'inventory-hero',
    section: 'Hero Background',
    page: 'Inventory',
    label: 'Used Cars for Sale Warrenton OR — Rockhound Auto Inventory Oregon Coast',
    defaultUrl: buildShortHeroImageUrl(
      'diverse collection of quality used vehicles parked in organized rows at modern dealership lot Pacific Northwest setting mountain backdrop clean well maintained cars trucks and SUVs professional automotive inventory display',
      'inventoryhero001'
    ),
    width: 1920,
    height: 600,
  },
  // FINANCING PAGE
  {
    id: 'financing-hero',
    section: 'Hero Background',
    page: 'Financing',
    label: 'Auto Financing Oregon Coast — Rockhound Auto Car Loans Warrenton OR',
    defaultUrl: buildShortHeroImageUrl(
      'car buyer reviewing financing paperwork at simple desk with calculator and loan documents casual office setting no luxury no fancy furniture just honest straightforward car loan consultation Pacific Northwest small business atmosphere',
      'financinghero-simple-v2'
    ),
    width: 1920,
    height: 600,
  },
  // CONTACT PAGE
  {
    id: 'contact-hero',
    section: 'Hero Background',
    page: 'Contact',
    label: 'Contact Rockhound Auto — Used Car Dealer 1425 SE 9th St Warrenton OR 97146',
    defaultUrl: buildShortHeroImageUrl(
      'friendly used car dealer greeting customer in simple office reception area basic desk with computer and phone casual welcoming atmosphere no fancy showroom no luxury just honest approachable small business environment Pacific Northwest setting',
      'contacthero-simple-v2'
    ),
    width: 1920,
    height: 600,
  },
];